import { render } from "./SingleTrade.vue?vue&type=template&id=7d18b593&scoped=true"
import script from "./SingleTrade.vue?vue&type=script&lang=js"
export * from "./SingleTrade.vue?vue&type=script&lang=js"

import "./SingleTrade.vue?vue&type=style&index=0&id=7d18b593&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d18b593"]])

export default __exports__